GuidedActionCreator = require '../../../../actions/abstract/GuidedActionCreator'
ActionTypes = require '../../../../constants/ActionTypes'
DashboardAPI = require '../../../../api/DashboardAPI'

class LastDaysByShiftActionCreator extends GuidedActionCreator
  get: =>
    @dispatch type: ActionTypes.LAST_DAYS_STAT_REQUESTING

    DashboardAPI.getLastDaysByShift(
      (json) =>
        if json.success
          @dispatch
            type: ActionTypes.LAST_DAYS_STAT_SUCCESS
            payload: json.data
        else
          @dispatch
            type: ActionTypes.LAST_DAYS_STAT_ERROR
            payload: json.error
      (response) =>
        msg = 'An error occurred while getting last days by shift statistic'
        @dispatch
          type: ActionTypes.LAST_DAYS_STAT_ERROR
          payload: msg
    )

module.exports = LastDaysByShiftActionCreator